<template>
    <span v-cloak v-show="loading">
        <!-- <fa-icon :icon="['fas', 'circle-notch']" spin /> -->
        <i class="fad fa-sync-alt fa-spin"></i>
    </span>
</template>

<script>
export default {
    props: ['loading'],

    data: () => ({}),

    created() {
        //
    },

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
